import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { TemplateDto, TemplateUpsertBody } from "./templateDtos";

export type UpdateTemplateVars = {
  id: number;
  body: TemplateUpsertBody;
};

// PUT /v2/support/treatments/schedules/:id — updates a standardized (library) template.
export const useUpdateTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, body }: UpdateTemplateVars): Promise<TemplateDto> => {
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      return api.parse(`PUT /treatments/schedules/${id}`, { root: supportApiBase, data: body });
    },
    {
      onSuccess: (_res, { id }) => {
        queryClient.invalidateQueries(queryKeys.templates());
        queryClient.invalidateQueries(queryKeys.template(id));
      },
    }
  );
};
